export default {
	VIDEO_STATE_PLAYING: 'playing',
	VIDEO_STATE_PAUSED: 'paused',
	VIDEO_STATE_SEEKING: 'seeking',
	VIDEO_STATE_BREAKPOINT_SELECTED: 'breakpoint-selected',
}
